import { Component, effect } from '@angular/core';
import { SpinnerService } from '../../services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mmg-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  private subs = new Subscription();

  public show = false;

  constructor(private spinnerService: SpinnerService) {
    effect(() => this.show = this.spinnerService.status$());
  }

  ngOnInit(): void {
    this.subs.add(this.spinnerService.state$
      .subscribe(state => this.show = state));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}